var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.741 4.8999H4.25767C2.83267 4.8999 1.66602 6.06656 1.66602 7.49156V16.9582C1.66602 18.1666 2.53268 18.6832 3.59101 18.0916L6.86601 16.2666C7.21601 16.0749 7.78268 16.0749 8.12435 16.2666L11.3993 18.0916C12.4577 18.6832 13.3243 18.1666 13.3243 16.9582V7.49156C13.3327 6.06656 12.166 4.8999 10.741 4.8999Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 7.49156V16.9582C13.3327 18.1666 12.466 18.6749 11.4077 18.0916L8.13269 16.2666C7.78269 16.0749 7.21601 16.0749 6.86601 16.2666L3.59101 18.0916C2.53268 18.6749 1.66602 18.1666 1.66602 16.9582V7.49156C1.66602 6.06656 2.83267 4.8999 4.25767 4.8999H10.741C12.166 4.8999 13.3327 6.06656 13.3327 7.49156Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 4.25816V13.7248C18.3327 14.9332 17.466 15.4415 16.4077 14.8582L13.3327 13.1415V7.4915C13.3327 6.0665 12.166 4.89984 10.741 4.89984H6.66602V4.25816C6.66602 2.83316 7.83267 1.6665 9.25767 1.6665H15.741C17.166 1.6665 18.3327 2.83316 18.3327 4.25816Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.02c63f204d3e23aa278c66b856bc524a.svg";
export { ForwardRef as ReactComponent };